export default {
  namespaced: true,
  state: {
    certificates: [
      {
        smallImg: require("@/assets/new-certs/cert1.jpg"),
        largeImg: require("@/assets/new-certs/Декларация_о_соответствии_Песок_дробленный_1,2_класса_page-0001.jpg"),
        filename: require("@/assets/files/new-certs/Декларация о соответствии Песок дробленный 1,2 класса.pdf"),
      },
      {
        smallImg: require("@/assets/new-certs/cert2.jpg"),
        largeImg: require("@/assets/new-certs/Декларация_о_соответствии_Щебень_5-20,20-40,40-70_pages-to-jpg-0001.jpg"),
        filename: require("@/assets/files/new-certs/Декларация о соответствии Щебень 5-20,20-40,40-70.pdf"),
      },
      {
        smallImg: require("@/assets/new-certs/cert3-small.jpg"),
        largeImg: require("@/assets/new-certs/cert3.jpg"),
        filename: require("@/assets/files/new-certs/cert3.pdf"),
      },
      {
        smallImg: require("@/assets/new-certs/cert4.jpg"),
        largeImg: require("@/assets/new-certs/СТ_КЗ_2020_page-0001.jpg"),
        filename: require("@/assets/files/new-certs/СТ КЗ 2020.pdf"),
      },
      {
        smallImg: require("@/assets/new-certs/cert5-small.jpg"),
        largeImg: require("@/assets/new-certs/cert5.jpg"),
        filename: require("@/assets/files/new-certs/cert5.pdf"),
      },
      {
        smallImg: require("@/assets/new-certs/cert6-small.jpg"),
        largeImg: require("@/assets/new-certs/cert6.jpg"),
        filename: require("@/assets/files/new-certs/cert6.pdf"),
      },
    ],
  },
  getters: {
    certificates(state) {
      return state.certificates;
    },
  },
};
